import app from './app'
import tk from './tk'
import tkInt from './tkInt'
import tr from './tr'
import ht from './ht'
import car from './car'
import visa from './visa'
import travelInfo from './travelInfo'
import trip from './trip'
import checkIn from './checkIn'
import restRoom from './restRoom'
import fastCheck from './fastCheck'
import guestPass from './guestPass'
import invoice from './invoice'

export default {
  app,
  tk,
  tkInt,
  tr,
  ht,
  car,
  visa,
  travelInfo,
  trip,
  checkIn,
  restRoom,
  fastCheck,
  guestPass,
  invoice
}
